export class Schema {
  identifier: string = "";
  name: string = "";
  title: string | null = null;

  constructor(init?: Partial<Schema>) {
    Object.assign(this, init);
  }

  static parse(data: any): Schema {
    return new Schema({
      identifier: data.identifier ?? "",
      name: data.name ?? "",
      title: data.title ?? null,
    });
  }
}
